import { type Meta } from '../types/docs';
import { AUTOMATION_OPENED_LOCATIONS, AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM } from './automationsAnalytics';

const META: Meta = {
  description: 'The user opens an automation from the list',
  name: 'automation_opened',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The automation that was opened',
      name: 'automation_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Where the automation was opened from',
      name: 'location',
      required: true,
      type: 'enum',
      values: [...AUTOMATION_OPENED_LOCATIONS],
    },
  ],
};

export default META;
